// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1VcPO","visible-sm":"visible-sm___2zn_J","visible-md":"visible-md___LWn4G","visible-lg":"visible-lg___-4jUb","row":"row___2MoQv","hidden-xs":"hidden-xs___1xjto","hidden-sm":"hidden-sm___z5sbn","hidden-md":"hidden-md___pvxyQ","hidden-lg":"hidden-lg___3o0OO","main":"main___1owLr page___2ZhHk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Redirect/Redirect.css
// module id = 947
// module chunks = 0